import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import { verifyToken, setAuthFromStorage } from '../store/authSlice';

function PrivateRoute({ children }) {
  const dispatch = useDispatch();
  const { isAuthenticated, loading, accessToken } = useSelector((state) => state.auth);

  useEffect(() => {
    // On mount, check if we have tokens in localStorage
    const storedAccessToken = localStorage.getItem('accessToken');
    const storedRefreshToken = localStorage.getItem('refreshToken');

    if (storedAccessToken && storedRefreshToken && !isAuthenticated) {
      // Set auth from storage first
      dispatch(setAuthFromStorage());
      // Then verify the token is still valid
      dispatch(verifyToken());
    }
  }, [dispatch, isAuthenticated]);

  // Show loading spinner while verifying token
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If not authenticated and no token in storage, redirect to login
  if (!isAuthenticated && !accessToken) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render the protected component
  return children;
}

export default PrivateRoute;
